export default __webpack_public_path__ + "media/images/footer-dog-0bff50b6bfeef07d41296f6a1b9d0760.svg";